import Vue from "vue";
import VueRouter from "vue-router";
import config from "../../config";
Vue.use(VueRouter);

const routes = [...config.routersName];

const router = new VueRouter({
  mode: "hash",
  base: process.env.VUE_APP_BASE,
  routes,
});

export default router;
